import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import date_range from "../../../../assets/icons/white/date_range.svg";
import moment from 'moment';
import { COUNTRY_CODE, DATE_FORMAT, INPUT_TYPE } from '../../../../constants/Constant';
import PayrollService from '../../../../services/PayrollService';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
export default class W3FormsForEmployee extends Component{
    formType = 'W3';
    constructor(props){
        super(props)
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    export(){
        let userId = TenantService.get(TENANT.USER_ID)
        let users = []
        let fileName = `${TenantService.get(TENANT.FIRST_NAME)}_${TenantService.get(TENANT.LAST_NAME)}_${this.formType}.pdf` ;
        
        
        users.push(userId)
        ReportService.downloadForm(users,this.formType).then(
            (response) => {
                
                saveAs(response,fileName);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
            }, (error) => {
                showToast("Internal Server Error", TOAST_TYPE.FAILURE);
            }
        )
    }
    render(){
        return(
            <div className="parent-width">
                <DKLabel text="W3 Form" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                    <DKLabel text="W3 Form" className="fw-m fs-l p-l" />
                    <DKLine  className="bg-gray3  "/>
                    <div className="d-flex p-h-l">
                        
                        
                        
                        <div className="mb-xs mr-l" style={{marginTop: '30px'}}>
                            <DKButton
                            title="DOWNLOAD FORM"
                            icon={DKIcons.white.ic_download}
                            className="bg-app text-white "
                            onClick={()=>{
                                this.export();
                            }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}